export default __webpack_public_path__ + "static/media/idan-raichel_memaamakim.277c4179.mp3";